import i18n from '../i18n';

export const formatLocationTypeOptions = locationTypes =>
  locationTypes.map(locationType => (
    {
      ...locationType,
      label: locationType.locationTypeName,
      value: locationType.id,
    }
  ));

export const formatPositionOptions = (positions, options) => 
  positions.map(position => {
    const i18nName = i18n.t(`positions:${position.name}`);
    return {
      id: position.id,
      name: i18nName,
      label: i18nName,
      isActive: position.isActive,
      isDisabled: !position.isActive,
      value: position.id,
      ...options,
    }
  });

export const findAgentOptions = (groupedAgents, agentIds) => {
  let agentOptions = [];

    for(let i = 0; i < groupedAgents.length; i++) {
      agentOptions = agentOptions.concat(
        groupedAgents[i].options.filter(
          option => agentIds.includes(option.value)
        )
      );
    }
    return agentOptions;
}

export const mapAgentEntities = agent =>
  ({
    ...agent,
    name: `${agent.firstName} ${agent.lastName}`,
    label: `${agent.firstName} ${agent.lastName}`,
    value: agent.id,
    isSelected: false
  });

export const mapOriginEntities = origin =>
  ({
    id: origin.id,
    name: origin.originName,
    label: origin.originName,
    value: origin.id,
    isSelected: false
  });